import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import { AgentConversationOriginalOutboundMessage } from 'shared';

import { CustomIframe } from '../../IFrame';

import { formatLocalTimestamp } from './conversationHelpers';

interface OriginalOutboundMessageProps {
  message: AgentConversationOriginalOutboundMessage;
  sourceActionId?: string | null;
  onViewAction?: (actionId: string) => void;
}

export function OriginalOutboundMessage({
  message,
  sourceActionId,
  onViewAction,
}: OriginalOutboundMessageProps) {
  const resolvedActionId = sourceActionId || null;
  const canViewAction = Boolean(resolvedActionId && onViewAction);
  const timestamp = message.sentAt ? formatLocalTimestamp(message.sentAt) : null;

  return (
    <div className={ `flex justify-end` }>
      <div className={ `max-w-3xl` }>
        <div className={ `mb-1 flex items-center justify-end gap-2 text-xs text-gray-500` }>
          <span className={ `text-right` }>
            { `Conversation started with an outbound ${message.channel.toUpperCase()}` }
            { timestamp ? ` · ${timestamp}` : `` }
          </span>
          {
            canViewAction &&
            <button
              type={ `button` }
              className={ `rounded-sm p-0.5 text-gray-400 transition hover:bg-gray-100 hover:text-gray-600` }
              title={ `View action` }
              aria-label={ `View action` }
              onClick={ () => {
                if (!resolvedActionId) {
                  return;
                }

                onViewAction?.(resolvedActionId);
              } }
            >
              <ArrowTopRightOnSquareIcon className={ `h-3.5 w-3.5` } />
            </button>
          }
        </div>
        {
          message.channel === `email` ?
            <div className={ `rounded-2xl rounded-tr-md border border-indigo-200 bg-indigo-50 shadow-xs overflow-hidden` }>
              <div className={ `px-4 pt-3` }>
                {
                  message.to &&
                  <div className={ `text-xs text-gray-500` }>
                    { `To: ` }<span className={ `font-medium text-gray-700` }>{ message.to }</span>
                  </div>
                }
                {
                  message.subject &&
                  <div className={ `mt-1 text-sm font-semibold text-gray-900` }>
                    { message.subject }
                  </div>
                }
              </div>
              <div className={ `mt-2` }>
                {
                  message.html ?
                    <CustomIframe
                      style={ {
                        width: `100%`,
                        minHeight: `270px`,
                        border: `none`,
                        backgroundColor: `white`,
                      } }
                      srcDoc={ message.html || `` }
                    /> :
                    <div className={ `p-4 text-sm text-gray-500 italic` }>
                      { `Archive not available` }
                    </div>
                }
              </div>
            </div> :
            <div className={ `max-w-xl rounded-2xl rounded-tr-md border border-indigo-200 bg-indigo-50 shadow-xs overflow-hidden` }>
              <div className={ `px-4 py-3` }>
                {
                  message.to &&
                  <div className={ `text-xs text-gray-500` }>
                    { `To: ` }<span className={ `font-medium text-gray-700` }>{ message.to }</span>
                  </div>
                }
                <div className={ `mt-2 text-sm text-gray-900 whitespace-pre-wrap wrap-break-word` }>
                  { message.body || `-` }
                </div>
              </div>
            </div>
        }
      </div>
    </div>
  );
}
